<template>
  <div>
    <lu-table
      ref="selectTable"
      @select="selectChange"
      @select-all="selectAll"
      :data="tableData"
    >
      <lu-table-column type="selection" width="55"> </lu-table-column>
      <!-- <lu-table-column width="65">
        <template prop="checkstatus" slot="header" slot-scope="scope">
          <lu-checkbox v-model="checkstatusAll" ></lu-checkbox>
        </template>
        <template slot-scope="scope">
          <lu-checkbox v-model="checkstatusList"></lu-checkbox>
        </template>
      </lu-table-column> -->
      <slot></slot>
    </lu-table>
  </div>
</template>

<script>
export default {
  name: "luTableSelected",
  data() {
    return {
      // checkstatusList:[true,false,false,false,true],
      // checkstatusAll:false,
      selectedDataIn: [], //选中数据的全部数据
      selectedDataInKeys: [] //选中数据的keyname数据
    };
  },
  async mounted() {
    this.selectedDataIn = [];
    this.selectedDataInKeys = [];
    this.selectedData.forEach(val => {
      //传入的selected 同步到组件已选择
      if (this.selectedDataInKeys.indexOf(val[this.keyword]) == -1) {
        this.selectedDataIn.push(val);
        this.selectedDataInKeys.push(val[this.keyword]);
      }
    });
    this.initTable();
  },
  props: {
    selectedData: {
      type: Array,
      default: function() {
        return [];
      }
    },
    tableData: {
      type: Array,
      default: function() {
        return [];
      }
    },
    updated: {
      type: Boolean,
      default: function() {
        return false;
      }
    },
    keyword: {
      type: String,
      default: function() {
        return "";
      }
    }
  },
  watch: {
    tableData: async function() {
      await this.$nextTick(); //dom 更新完成后处理table勾选
      this.initTable();
    },
    updated: function(val) {
      if (val) {
        let keyins = this.selectedData.map(val => val[this.keyword]);
        let diffInOut = this.array_func(keyins, this.selectedDataInKeys);
        //更新状态，清空已选择
        this.$emit(
          "update-selected",
          this.selectedDataIn,
          this.selectedDataInKeys,
          diffInOut
        );
        this.selectedDataIn = [];
        this.selectedDataInKeys = [];
        this.initTable();
      }
    },
    selectedData: function() {
      this.selectedDataIn = [];
      this.selectedDataInKeys = [];
      this.selectedData.forEach(val => {
        //传入的selected 同步到组件已选择
        if (this.selectedDataInKeys.indexOf(val[this.keyword]) == -1) {
          this.selectedDataIn.push(val);
          this.selectedDataInKeys.push(val[this.keyword]);
        }
      });
      this.initTable();
    }
  },
  methods: {
    initTable() {
      //勾选表格数据
      // await this.$nextTick()
      // this.$nextTick(() => {
      //表格勾选
      let i = 0;
      this.tableData.forEach(td => {
        this.$refs.selectTable.toggleRowSelection(this.tableData[i], false);
        this.selectedDataIn.forEach(selected => {
          if (selected[this.keyword] == td[this.keyword]) {
            this.$refs.selectTable.toggleRowSelection(this.tableData[i], true);
          }
        });
        i++;
      });
      // });
    },
    selectAll(selection) {
      //所有选中
      if (selection.length) {
        selection.forEach(val => {
          //当前页选中项循环，如果选中的没有添加过，加到选中里
          if (this.selectedDataInKeys.indexOf(val[this.keyword]) == -1) {
            this.selectedDataIn.push(val);
            this.selectedDataInKeys.push(val[this.keyword]);
          }
        });
      } else {
        //如果是取消全选，删除当前表格每一项
        this.tableData.forEach(val => {
          let index = this.selectedDataInKeys.indexOf(val[this.keyword]);
          if (index != -1) {
            this.selectedDataInKeys.splice(index, 1);
            this.selectedDataIn.splice(index, 1);
          }
        });
      }
    },
    selectChange(selection, row) {
      //所有选中,当前行
      let index = this.selectedDataInKeys.indexOf(row[this.keyword]);
      if (index != -1) {
        this.selectedDataInKeys.splice(index, 1);
        this.selectedDataIn.splice(index, 1);
      } else {
        this.selectedDataIn.push(row);
        this.selectedDataInKeys.push(row[this.keyword]);
      }
    },
    //传入传出比较数据
    array_func(Arr, Brr) {
      //1，2，3 -》 3，，4，5
      let a = new Set(Arr);
      let b = new Set(Brr);

      // 并集 a+b
      let unionSet = new Set([...a, ...b]);
      // 交集，在a也在b
      let intersectionSet = new Set([...a].filter(x => b.has(x)));
      // ab差集，在a不在b
      let differenceABSet = new Set([...a].filter(x => !b.has(x)));
      //在b 不在 a
      let differenceBASet = new Set([...b].filter(x => !a.has(x)));
      return {
        differenceAB: Array.from(differenceABSet),
        differenceBA: Array.from(differenceBASet),
        intersection: Array.from(intersectionSet),
        union: Array.from(unionSet)
      };
    }
  }
};
</script>
